<template>
  <div 
      :class="[
                'btn-wrapper',
        ]"
  >

  <template v-if="hasRecaptcha" >

    <!-- <form v-on:submit.prevent="onSubmit"> -->
      <div class="btn-wrapper">
        <vue-recaptcha 
            :class="[
                    'captcha',
                    validCaptcha == true ? 'solved' : ''
                  ]"
            @verify="onCaptchaVerified"
            @expired="onCaptchaExpired"
            sitekey="6LfHcdoUAAAAAB33moB0X3iT_g-I6ca_vEeQqSfT"
        ></vue-recaptcha>

        <button
          type="submit"
          @click="onSubmit"
          :class="[
                    'button',
                    validForm == true ? '' : 'disabled',
                  ]"
        >
            <p 
              :class="[
                'btn-label',
                isRunning == true ? 'hide' : '',
              ]"
            >{{label}}</p>

            <div 
              :class="[
                'loader',
                isRunning == true ? 'show' : '',
              ]"
            ></div>   
                     
        </button>

        

      <!-- </form> -->
    </div>

    <div class="captcha-error" v-if="validCaptcha === false">
    </div>

  </template>


  <template v-else >
    <button
      :class="[
                'button',
                isValid == true ? '' : 'disabled',
              ]"
      @click="(e) => onSubmit(e) "
    >

        <p :class="[
              'btn-label',
              isRunning == true ? 'hide' : '',
            ]">
        {{label}}</p>

        <div 
          :class="[
            'loader',
            isRunning == true ? 'show' : '',
          ]"
        ></div>   

    </button>
  </template>  



  </div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';

export default {
    name: 'Button',
    components: {
      VueRecaptcha
    },

    data(){
      return {
        validCaptcha: undefined,
        isRunning: false,
      }
    },

    props: {
        hasRecaptcha: {
          type: Boolean,
          default: false
        },
        label: String,
        callback: Function,
        hasSpinner: {
          default: false,
          type: Boolean,
        },
        isValid: {
          type: Boolean,
          default: true,
        }
    },

    computed: {
    },

    mounted(){
      // console.log('recap val: ', grecaptcha)
    },

    methods: {

      onSubmit(e){

        if(this.isValid && this.isRunning == false){ 

          if(this.hasSpinner) 
            this.isRunning = true;

          this.callback(e);  
        }      

      },

      onCaptchaVerified(){
        this.validCaptcha = true;        

      },

      onCaptchaExpired(){
        this.validCaptcha = false;
      },

    }
}

</script>

<style lang="scss" scoped>
@import "../../styles/_variables.scss";
@import "../../styles/_mixins.scss";

  .loader {
    @include loader;
    opacity: 0;
    touch-action: none;

    &.show {
      opacity: 1;

    }

  }

  .btn-wrapper {
    margin: auto;
    text-align: center;
  }

  .captcha {
    margin: auto;
    display: flex;
    align-content: center;
    justify-content: center;
    align-items: center;
    padding-bottom: 10px;
    width: 100%;
    position: absolute;
    z-index: 10;
    opacity: 1;

    &.solved{
      display: none;
      pointer-events: none;
      opacity: 0;
    }

  }

  .captcha-error {
    position: relative;
    width: 100%;
    font-size: 0.75rem;

    &::after {
      content: "reCaptcha expired, try again";
      position: absolute;
      margin: 10px auto 0 auto;
      left: 0; right: 0;
      color: red;
      width: 100%;
    }
    
  }

  .btn-wrapper {
    position: relative;

    transition: all 0.25s ease;

    &.hasMini{
      &::after {
        content: '';

      width: 80px;
      height: 95px;
      position: absolute;
      right: 0;
      margin-top: -1.5rem;

        background-image: url('../../../public/assets/egg_beta_with_shadow.png');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        opacity: 1.0;
      }
    }

    &.out {
      opacity: 0.0;
      @include crossBrowser(transform, translateY(-10%));

    }

  }

  button {
    padding: 0;
    margin: 0;
    text-align: center;
    position: relative;
    cursor: pointer;

  }

  .btn-label {
    @include fontStack;

    color: $yellow;
    font-size: 1.4rem;
    line-height: 1.35em;
    padding: 0.75em 1.5em;
    margin: auto;
    margin-top: 0.15em;
    width: inherit;
    line-height: inherit;

    &.hide {
      opacity: 0;
    }

  }

  .button {
    background-color: $orange-dark;
    -webkit-tap-highlight-color: transparent;

    border: none;
    border-radius: 0.75em;
    transition: opacity 0.5s ease-in-out;
    min-width: 55%;

    &.disabled {
      opacity: 0.5;
    }

  }

</style>